const hasOptedOutOfUat = () => localStorage.getItem('uatNewBookingOptOut') === 'true';
const optOutOfUat = (optOut: boolean) => localStorage.setItem('uatNewBookingOptOut', String(optOut));

export {
  hasOptedOutOfUat,
  optOutOfUat
};
